const firebaseConfig = {
  apiKey: "AIzaSyAQI-92ZDEejN3YHxrCLYyNs7qO4l_mECQ",
  authDomain: "azim-u-ahamed.firebaseapp.com",
  databaseURL: "https://azim-u-ahamed.firebaseio.com",
  projectId: "azim-u-ahamed",
  storageBucket: "azim-u-ahamed.appspot.com",
  messagingSenderId: "23509590836",
  appId: "1:23509590836:web:01e6cf18262a885a1f3b61",
};
export default firebaseConfig;
